import { lazy, type ComponentType } from "react";

import type { HeatmapLayerProps } from "@deck.gl/aggregation-layers";
export type BaseHeatmapLayerProps = Omit<HeatmapLayerProps, "id">;
export { PathStyleExtension } from "@deck.gl/extensions";
export { HeatmapLayer as BaseHeatmapLayer } from "@deck.gl/aggregation-layers";
export {
  _GeoCellLayer as BaseGeoCellLayer,
  type _GeoCellLayerProps as BaseGeoCellLayerProps,
} from "@deck.gl/geo-layers";

export { CompositeLayer } from "@deck.gl/core";
export type { GoogleProviderOptions, YandexProviderOptions } from "./map";

const lazyGeneric = <T>(factory: () => Promise<T>): T => {
  return lazy(() =>
    factory().then((value) => ({ default: value as ComponentType<any> })),
  ) as T;
};

export const Map = lazyGeneric(() =>
  import("./map").then((module) => module.Map),
);

export const Layer = lazyGeneric(() =>
  import("./layer").then((module) => module.Layer),
);
export const IconLayer = lazyGeneric(() =>
  import("./layer").then((module) => module.IconLayer),
);
export const ScatterplotLayer = lazyGeneric(() =>
  import("./layer").then((module) => module.ScatterplotLayer),
);
export const PathLayer = lazyGeneric(() =>
  import("./layer").then((module) => module.PathLayer),
);
export const TextLayer = lazyGeneric(() =>
  import("./layer").then((module) => module.TextLayer),
);
export const PolygonLayer = lazyGeneric(() =>
  import("./layer").then((module) => module.PolygonLayer),
);
export const HtmlLayer = lazyGeneric(() =>
  import("./layer").then((module) => module.HtmlLayer),
);
export const ArcLayer = lazyGeneric(() =>
  import("./layer").then((module) => module.ArcLayer),
);
export const LineLayer = lazyGeneric(() =>
  import("./layer").then((module) => module.LineLayer),
);
export const BitmapLayer = lazyGeneric(() =>
  import("./layer").then((module) => module.BitmapLayer),
);
export const PointCloudLayer = lazyGeneric(() =>
  import("./layer").then((module) => module.PointCloudLayer),
);
export const ColumnLayer = lazyGeneric(() =>
  import("./layer").then((module) => module.ColumnLayer),
);
export const GridCellLayer = lazyGeneric(() =>
  import("./layer").then((module) => module.GridCellLayer),
);
export const GeoJsonLayer = lazyGeneric(() =>
  import("./layer").then((module) => module.GeoJsonLayer),
);
export const SolidPolygonLayer = lazyGeneric(() =>
  import("./layer").then((module) => module.SolidPolygonLayer),
);
export const QuadkeyLayer = lazyGeneric(() =>
  import("./layer").then((module) => module.QuadkeyLayer),
);
export { midpoint } from "./geometry";
export { calculateViewport, calculateBoundsByViewport } from "./viewport";
export type { Provider, Viewport } from "./types";
